import { Controller } from "@hotwired/stimulus"
import React from "react";
import { createRoot } from "react-dom/client";
import PrizeGroups from "../components/PrizeGroups.jsx";

export default class extends Controller {
  static values = {
    eventId: Number,
    teamsPrizesVal: Number
  };
  connect() {
    document.addEventListener("turbo:load", () => {
      if (!this.root) {
        this.root = createRoot(this.element);
      }
      const props = {
        id: this.hasEventIdValue ? this.eventIdValue : null,
        teamsPrizesVal: this.hasTeamsPrizesValValue ? this.teamsPrizesValValue : 0,
      };
      this.root.render(<PrizeGroups {...props} />);
    });
  }
  
}